module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      active: _vm.isActive
    },
    on: {
      "click": _vm.setNewType
    }
  }, [_vm._v(_vm._s(_vm.type))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ba2b7214!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectType.vue
// module id = 590
// module chunks = 2